module.exports = __webpack_public_path__ + "static/img/27.5f6093a3.png";